<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <f7-block>
    <p>Muestra un preload de carga de elementos</p>
    <f7-row>
      <f7-col>
        <f7-button
          fill
          color="green"
          @click="ActivateUCPreload()"
        >
          Activar UCPreload
        </f7-button>
      </f7-col>
      <f7-col>
        <f7-button
          fill
          color="gray"
          @click="DesactivatePreload()"
        >
          Desactivar UCPreload
        </f7-button>
      </f7-col>
    </f7-row>
    <f7-row>
      <f7-col
        class="display-flex align-items-center justify-content-center flex-direction-column margin-top"
        width="100"
      >
        <p class="display-flex justify-content-center">
          Número de Preloads:
        </p>
        <UCInputIncrement
          :max-valor="Number(10)"
          :val="preloadNum"
          @value="ChangeUCPreloadNumber($event)"
        />
      </f7-col>
    </f7-row>
    <UCPreload
      :show="showUCPreload"
      :number="preloadNum"
    />
  </f7-block>
</template>

<script>
import UCPreload from '@/components/common/UCPreload.vue';
import UCInputIncrement from '@/components/common/UCInputIncrement.vue';

export default {
  name: 'TestUCPreload',
  components: {
    UCPreload,
    UCInputIncrement,
  },
  data() {
    return {
      showUCPreload: false,
      preloadNum: 2,
    };
  },
  methods: {
    ActivateUCPreload() {
      this.showUCPreload = true;
    },
    DesactivatePreload() {
      this.showUCPreload = false;
    },
    ChangeUCPreloadNumber(val) {
      this.preloadNum = val;
    },
  },
};
</script>
